<template>
  <div style="display:flex">
    <div
      class="column5 border-left border-bottom border-top border-dark p-1"
      style="height: auto"
    >
      {{ indexRow }}
    </div>
    <div
      class="column30 border-bottom border-top border-dark p-1"
      style="height: auto"
    >
      {{ desc }}
    </div>
    <div
      class="column5 border-bottom border-top border-dark text-center p-1"
      style="height: auto"
    >
      :
    </div>
    <div
      :class="
        `border-bottom border-top border-dark p-1 ${
          value_2 ? 'column30' : 'column60 border-right'
        } col-nohover`
      "
      style="height: auto"
    >
      {{ value_1 }}
    </div>
    <div
      :class="
        `column30 border-right border-bottom border-top border-dark p-1 text-center ${
          addBorder ? 'border-left' : ''
        }`
      "
      v-if="value_2"
      style="height: auto"
    >
      {{ value_2 ? value_2 : null }}
    </div>
  </div>
</template>
<script>
export default {
  props: ['indexRow', 'desc', 'value_1', 'addBorder', 'value_2'],
}
</script>
